/* eslint-disable no-lone-blocks */
import axios from 'axios';
import { Message } from 'element-ui';

// create an axios instance
const service = axios.create({
  headers: { 'Content-Type': 'application/json; charset=utf-8' },
  timeout: 60000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    // 如果状态码不等于200 则是接口调用失败
    if (response.status !== 200) {
      return Promise.reject(new Error(response.message || 'Error'));
    } else {
      if (response.data.error) {
        Message({
          message: response.data.error,
          type: 'error',
          duration: 2 * 1000
        });
      } else {
        return response.data;
      }
    }
  },
  (error) => {
    // console.log('err' + error.response.status) // for debug
    if (error.response) {
      switch (error.response.status) {
        // eslint-disable-next-line no-lone-blocks
        case 500:
          {
            Message({
              message: '服务器异常',
              type: 'error',
              duration: 5 * 1000
            });
          }
          break;
      }
    } else {
      Message({
        message: '响应超时，请重试',
        type: 'error',
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js